module.exports = __webpack_public_path__ + "static/media/bg_america.ef76336a.jpg";